import COUNTRY_CODES from "../components/PhoneNumberInput/jsons/COUNTRY_CODES.json";

export const getDefaultPhoneCodeUtil = (lc: string) =>
  COUNTRY_CODES.find((k) => k.code === lc.toUpperCase())?.code || "";
